import React from 'react'
import styles from './styles.module.scss'
import PropTypes from 'prop-types'

const Label = ({ children, ariaLabel, size, className, ...rest }) => {
  return (
    <label aria-label={ariaLabel} className={`${styles.label} ${styles[size]} ${className}`} {...rest}>
      {children}
    </label>
  )
}

Label.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  ariaLabel: PropTypes.string.isRequired,
  className: PropTypes.string
}

Label.defaultProps = {
  size: 'medium',
  ariaLabel: '',
  className: ''
}

export default Label
